import { gql } from '@apollo/client';

export const CREATE_SURROUNDING_INFORMATION_PROPERTY_MUTATION = gql`
  mutation CreateSurroundingInformationProperty($data: SurroundingInformationPropertyInput!) {
    createSurroundingInformationProperty(input: { data: $data }) {
      surroundingInformationProperty {
        id
      }
    }
  }
`;
